import { css } from '@emotion/react';

import { standardSpacing } from 'styles/global_defaults/scaffolding';
import { handheld, notDesktop } from 'styles/global_defaults/media-queries';

import FlipCard, { FlipCardData } from './flip-card';

type FlipCardGridProps = {
  cards: FlipCardData[],
};

const FlipCardGrid = ({ cards }: FlipCardGridProps) => {
  const styles = css`
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: ${standardSpacing}px;

    ${notDesktop(css`
      grid-template-columns: repeat(2, 1fr);
    `)}

    ${handheld(css`
      grid-template-columns: 1fr;
    `)}
  `;

  return (
    <div css={styles}>
      {cards.map((card) => (
        <FlipCard key={card.id} card={card} />
      ))}
    </div>
  );
};

export default FlipCardGrid;
